document.addEventListener("DOMContentLoaded", function () {
  const currency = window.Shopify?.currency?.active || "EUR";

  function getCartValue() {
    const totalSpan = document.querySelector(".totals__subtotal-value");
    if (!totalSpan) return 0;
    // Estrae il testo, rimuove simboli di valuta e "EUR", sostituisce virgola con punto
    const text = totalSpan.textContent.trim();
    const numericValue = text
      .replace(/[€\s]/g, "")
      .replace("EUR", "")
      .replace(/\./g, "")
      .replace(",", ".");
    return parseFloat(numericValue) || 0;
  }

  function getProductDataByVariantId(variantId) {
    const script = document.querySelector(
      `[data-product-data][data-variant-id="${variantId}"]`
    );
    if (!script) {
      console.warn("No product data found for variantId", variantId);
      return null;
    }
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error("Error parsing product data for variantId", variantId, e);
      return null;
    }
  }

  function pushEventToDataLayer(type, variantId, quantityOverride) {
    const productData = getProductDataByVariantId(variantId);
    if (!variantId || !productData) return;

    const maxPrice = productData.compare_at_price || productData.price;
    const finalPrice = productData.price;
    const discount = parseFloat(Math.max(0, maxPrice - finalPrice).toFixed(2));
    const itemId = productData?.sku ?? '';
    const cartValue = getCartValue();

    let quantity = quantityOverride || 1;

    const eventData = {
      event: type,
      ecommerce: {
        currency: currency,
        value: cartValue,
        items: [
          {
            item_id: itemId,
            item_name: productData.title,
            item_brand: productData.vendor,
            price: finalPrice,
            quantity: quantity,
            discount: discount,
          },
        ],
      },
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(eventData);
  }

  document.body.addEventListener("click", function (e) {
    const plusBtn = e.target.closest('button[name="plus"]');
    const minusBtn = e.target.closest('button[name="minus"]');
    const removeBtn = e.target.closest(
      'a[is="cart-remove-item"], a.btn-remove, cart-remove-button a, a.button--tertiary[aria-label*="remove"], a.button--tertiary[aria-label*="Remove"]'
    );

    if (plusBtn) {
      const wrapper = plusBtn.closest("quantity-input") || plusBtn.closest("tr.cart-item");
      if (!wrapper) return;
      const input = wrapper.querySelector(".quantity__input");
      const variantId = input?.dataset.quantityVariantId;
      if (variantId) pushEventToDataLayer("add_to_cart", variantId, 1);
      return;
    }

    if (minusBtn) {
      const wrapper = minusBtn.closest("quantity-input") || minusBtn.closest("tr.cart-item");
      if (!wrapper) return;
      const input = wrapper.querySelector(".quantity__input");
      const variantId = input?.dataset.quantityVariantId;
      if (variantId) pushEventToDataLayer("remove_from_cart", variantId, 1);
      return;
    }

    if (removeBtn) {
      const tr = removeBtn.closest("tr.cart-item") || removeBtn.closest(".cart-item");
      if (!tr) return;
      const input = tr.querySelector(".quantity__input");
      const variantId = input?.dataset.quantityVariantId;
      let quantity = 1;
      if (input && input.value) {
        quantity = parseInt(input.value, 10) || 1;
      }
      if (variantId) pushEventToDataLayer("remove_from_cart", variantId, quantity);
      return;
    }
  });
});
